// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:40
import { DeferArgs_abstract } from './../../abstract/SagaBase/Defines/DeferArgs_abstract';
export class DeferArgs extends DeferArgs_abstract {}
